import axios from "axios";
import authHeader from "../auth-header";
const { REACT_APP_API_URL } = process.env;

class CommonService {
  CheckMappedItem(Param) {
    return axios.get(
      REACT_APP_API_URL +
        "/Master/CheckDelete?DeleteID=" +
        Param.DeleteID +
        "&DeleteType=" +
        Param.DeleteType,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  ProductExistCheck(Param) {
    return axios.get(
      REACT_APP_API_URL +
        "/Product/ProductExistCheck?ProductID=" +
        Param.ProductID +
        "&ProductName=" +
        Param.ProductName +
        "&SKU=" +
        Param.SKU +
        "&WarehouseID=" +
        Param.WarehouseID +
        "&CategoryID=" +
        Param.CategoryID +
        "&SubCategoryID=" +
        Param.SubCategoryID +
        "&VendorID=" +
        Param.VendorID,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  ProductLocationExistCheck(Params) {
    return axios({
      method: "post",
      url: REACT_APP_API_URL + "/Product/ProductLocationExistCheck",
      data: Params,
      headers: {
        authorization: authHeader(),
      },
    });
  }

  AttributeExistsCheck(Param) {
    return axios.get(
      REACT_APP_API_URL +
        "/Attribute/AttributeExistCheck?AttributeID=" +
        Param.AttributeID +
        "&AttributeName=" +
        Param.AttributeName,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  GetOrderPackingSlipByID(OrderID) {
    return axios.get(
      REACT_APP_API_URL + "/Order/GetOrderPackingSlipByID?OrderID=" + OrderID,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }
  GetOrderBoxCount(Param) {
    return axios.get(
      REACT_APP_API_URL + "/Order/GetOrderBoxCount?OrderID=" + Param.OrderID,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  GetProductDetailsByID(Param) {
    return axios.get(
      REACT_APP_API_URL +
        "/Product/GetProductDetailsByID?ProductID=" +
        Param.ProductID,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  GetProductCurrentQuantity(Param) {
    return axios.get(
      REACT_APP_API_URL +
        "/Product/GetProductCurrentQuantity?ProductIDList=" +
        Param.ProductIDList,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  InsertUpdateOrder(Params) {
    return axios({
      method: "post",
      url: REACT_APP_API_URL + "/Order/InsertUpdateOrder",
      data: Params,
      headers: {
        authorization: authHeader(),
      },
    });
  }

  UpdateQuickBookData(Params) {
    return axios.get(
      REACT_APP_API_URL +
        "/QuickBookApi/UpdateQuickBookData?UserId=" +
        Params.UserId +
        "&OrderID=" +
        Params.OrderID +
        "&ClientEmailID=" +
        Params.ClientEmailID,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  GetNotificationCount(CurrentUserID) {
    return axios.get(
      REACT_APP_API_URL +
        "/User/GetNotificationCount?CurrentUserID=" +
        CurrentUserID,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  LotNumberExistCheck(Param) {
    return axios.get(
      REACT_APP_API_URL +
        "/Inventory/LotNumberExistCheck?LotNumber=" +
        Param.LotNumber +
        "&ProductID=" +
        Param.ProductID,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  LotNumberExistCheckForMRP(Param) {
    return axios.get(
      REACT_APP_API_URL +
        "/Inventory/LotNumberExistCheckForMRP?LotNumber=" +
        Param.LotNumber +
        "&ProductID=" +
        Param.ProductID +
        "&MerchandiseReceptionProductID=" +
        Param.MerchandiseReceptionProductID,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  PONumberExistCheck(Param) {
    return axios.get(
      REACT_APP_API_URL +
        "/Inventory/PONumberExistCheck?PurchaseOrderNumber=" +
        Param.PurchaseOrderNumber,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  TryLockMerchandiseReception(Param) {
    return axios.get(
      REACT_APP_API_URL +
        "/Inventory/TryLockMerchandiseReception?MerchandiseReceptionID=" +
        Param.MerchandiseReceptionID +
        "&CurrentUserID=" +
        Param.CurrentUserID,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  UnlockMerchandiseReception(Param) {
    return axios.get(
      REACT_APP_API_URL +
        "/Inventory/UnlockMerchandiseReception?MerchandiseReceptionID=" +
        Param.MerchandiseReceptionID,
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }

  CheckQuickBookConnection() {
    return axios.get(
      REACT_APP_API_URL + "/QuickBookApi/CheckQuickBookConnection",
      {
        headers: {
          authorization: authHeader(),
        },
      }
    );
  }
}

export default new CommonService();
